import React from 'react';
import './EasyToUse.css';

const EasyToUse = () => {
  return (
    <div className="easy-to-use-section">
      <h2 className="section-title">Easy to Use</h2>
      <div className="steps-container">
        <div className="step">
          <div className="step-icon">1</div>
          <div className="step-content">
            <h3>Turn on the ChipServer</h3>
            <p>Simply press the power button and watch it come to life!</p>
          </div>
        </div>
        
        <div className="step">
          <div className="step-icon">2</div>
          <div className="step-content">
            <h3>Connect to WiFi</h3>
            <p>Join the ChipServer's unique WiFi network</p>
          </div>
        </div>
        
        <div className="step">
          <div className="step-icon">3</div>
          <div className="step-content">
            <h3>Open Browser</h3>
            <p>Type "Chips.edu" in your browser and you're ready to share and manage your files!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EasyToUse; 